module.exports = {
  LOGIN: "login",
  ROOM_OR_MEETING_INVITATION: "room_or_meeting_invitation",
  MEETING_INVITATION: "meeting_invitation",
  PRODUCER_SELECTION: "producer_selection",
  LOBBY: "lobby",
  SMS: "sms",
  COMPLETED: "completed",
};
